import { toNumber } from '../../../utils/Utils';
import { RESULTADOS_KEY_ORDER, ResultadosRow, BuildResultadosRowsV2Args } from './types';

const getResultadosValue = (data: any, category: string, key: string): string | number => {
  const v = data?.[category]?.[key];
  return v ?? 0;
};

export function buildResultadosRowsV2({
  getTranslation,
  previousTotals,
  currentTotals,
  previousRiskData,
  currentRiskData,
  isOpen,
  isResultadoBrutoFiltered = false,
}: BuildResultadosRowsV2Args): ResultadosRow[] {
  const rows: ResultadosRow[] = [];

  rows.push({
    label: 'Resultados',
    // Figma: el header "Resultados" muestra el resultado del ejercicio (último valor)
    valuePrev: toNumber(previousTotals?.taxes),
    valueCurr: toNumber(currentTotals?.taxes),
    isBold: true,
    isResultadosGroupHeader: true,
    isResultadosDividerTop: true,
  });

  if (!isOpen) return rows;

  const pushBlock = (
    category: 'gross_result' | 'operating_result' | 'ordinary_result',
    subtotalLabel: string
  ) => {
    let keys = RESULTADOS_KEY_ORDER[category] ?? [];
    
    // Filtrar campos de Resultado Bruto si está habilitado
    if (category === 'gross_result' && isResultadoBrutoFiltered) {
      keys = keys.filter(
        (k) => k !== 'agricultural_production' && k !== 'production_cost'
      );
    }
    
    keys.forEach((k) => {
      rows.push({
        label: getTranslation(category, k),
        valuePrev: getResultadosValue(previousRiskData, category, k),
        valueCurr: getResultadosValue(currentRiskData, category, k),
        isBold: false,
      });
    });
    rows.push({
      label: subtotalLabel,
      valuePrev: previousTotals?.[category] ?? 0,
      valueCurr: currentTotals?.[category] ?? 0,
      isBold: true,
      isResultadosSubtotal: true,
      // separador abajo para cortar bloque
      isResultadosDividerBottom: true,
    });
  };

  pushBlock('gross_result', 'Resultado bruto');
  pushBlock('operating_result', 'Resultado operativo');
  pushBlock('ordinary_result', 'Resultado ordinario');

  rows.push({
    label: 'Ingresos extraordinarios',
    valuePrev: getResultadosValue(previousRiskData, 'result_before_taxes', 'extraordinary_income'),
    valueCurr: getResultadosValue(currentRiskData, 'result_before_taxes', 'extraordinary_income'),
    isBold: false,
  });
  rows.push({
    label: 'Egresos extraordinarios',
    valuePrev: getResultadosValue(previousRiskData, 'result_before_taxes', 'extraordinary_expenses'),
    valueCurr: getResultadosValue(currentRiskData, 'result_before_taxes', 'extraordinary_expenses'),
    isBold: false,
  });
  rows.push({
    label: 'Resultado antes de impuestos',
    valuePrev: (previousTotals?.result_before_taxes as any)?.total ?? previousTotals?.result_before_taxes ?? 0,
    valueCurr: (currentTotals?.result_before_taxes as any)?.total ?? currentTotals?.result_before_taxes ?? 0,
    isBold: true,
    isResultadosSubtotal: true,
    isResultadosDividerBottom: true,
  });

  // Figma: impuesto separado (entre dos líneas gruesas: arriba lo deja el subtotal anterior, abajo lo dejamos aquí)
  rows.push({
    label: 'Impuesto a las ganancias',
    valuePrev: toNumber(previousTotals?.income_tax_formatted),
    valueCurr: toNumber(currentTotals?.income_tax_formatted),
    isBold: false,
    isResultadosDividerBottom: true,
  });

  rows.push({
    label: 'Resultado del ejercicio',
    valuePrev: toNumber(previousTotals?.taxes),
    valueCurr: toNumber(currentTotals?.taxes),
    isBold: true,
    isResultadosSubtotal: true,
    isResultadosDividerBottom: true,
  });

  return rows;
}

